export const RouteMap = {
  CXAMain: "/dashboard",
  LogOut: "/logout",
  Login: "/login",
  CXAMain_EmployeeProfile: "/userProfile",
  CXAMain_ChangePassword: "/changePassword",
  Delegation: "/delegation",
  SearchDelegation: "/delegation/search",
  AddDelegation: "/delegation/add",
  EditDelegation: "/delegation/edit",

  HealthAndWellnessMain: "/wellness",
  HealthAndWellnessMain_HandWDashboard: "/wellness/launchpad",
  HealthAndWellnessMain_MentalWellness: "/wellness/mentalWellness",
  HealthAndWellnessMain_Aging: "/wellness/lifestyleAgeing",
  HealthAndWellnessMain_Biometrics: "/wellness/screening-results/basic",
  HealthAndWellnessMain_ActionPlan: "/wellness/screening-results/advanced",
  HealthAndWellnessMain_Activities: "/wellness/activities",
  HealthAndWellnessMain_eLibrary: "/wellness/elibrary/catalogue",
  HealthAndWellnessMain_Newsletter: "/wellness/newsletters",
  CXAShopActivitiesMain_CXAShopActivities: "/externalsite",

  NeedHelp_HelpEE: "/needHelp",
  FlexBenefitsMain: "/shop",
  FlexBenefitsMain_BenefitsEnrolment: "/shop/enrolment",
  FlexBenefitsMain_eCommerce: "/shop/health-wellness",
  FlexBenefitsMain_CheckOut: "/shop/checkout",
  FlexBenefitsMain_CheckOutSuccess: "/shop/checkout/success",
  FlexBenefitsMain_MyBenefits: "/benefits",
  FlexBenefitsMain_BenefitsStatement: "/benefits/statement",
  FlexBenefitsMain_BenefitsDocument: "/benefits/documents",
  FlexBenefitsMain_Survey: "/benefits/survey",
  FlexBenefitsMain_TotalRewardsStatement: "/benefits/reward-statement",
  FlexBenefitsMain_OtherBenefits: "/benefits/otherbenefits",
  FlexBenefitsMain_MyClaims: "/claims",
  FlexBenefitsMain_FSAStatement: "/claims/accounts",
  FlexBenefitsMain_NewClaims: "/claims/submit",
  FlexBenefitsMain_PendingClaims: "/claims/pending",
  FlexBenefitsMain_FlexClaimProcessedListing: "/claims/history",
  FlexBenefitsMain_TrackClaims: "/claims/track",
  FlexBenefitsMain_eCard: "/claims/eCards",

  ClaimDocuments: "/claims/documents",
  ClaimPreview: "/claims/preview",
  FlexBenefitsMain_Clinics: "/claims/clinics",
  BenefitsClinics: "/benefits/clinics",

  DonationMain: "/donations",
  DonationMain_NewDonation: "/donations/submit",
  DonationMain_PendingDonation: "/donations/pending",
  DonationMain_DonationHistory: "/donations/history",

  Contact: "/contact",

  HR_Impersonate: "/hr/admin/impersonate",
  ResetHRPassword: "/hr/admin/resetpassword",
  HRGrantConsent: "/hr/admin/grantconsent",
  ChangeHRPassword: "/hr/admin/changepassword",
  ReportsMain: "/hr/chart/dashboard",
  Sso_ExternalLogin: "/externallogin",

  CXAShopMain_CXAShop: "/marketplace",

  // Mapping for Survey Module Redirection
  EnrolmentSelection: "/shop/enrolment",
  EnrolmentCheckout: "/shop/checkout",
  BenefitsStatement: "/benefits/statement",

  // In-App Message
  InAppMessageHome: "/messages",

  //ShopLite
};



// WEBPACK FOOTER //
// ./components/common/navigation/routeMap.js